var React = require('react');
import Inviter from './Inviter';

class InviteExpander extends React.Component {

    constructor() {
        super();
        this.state = {
            expanded: false
        };
        this.onClick = this.onClick.bind(this)
        this.inviteeForm = this.inviteeForm.bind(this)
        this.getAddButtonText = this.getAddButtonText.bind(this)
    }

    onClick() {
        this.setState({
            expanded: !this.state.expanded
        })
    }

    inviteeForm() {
        if (this.state.expanded) {
            const brewery = JSON.parse(this.props.brewery).brewery;
            return (
                <Inviter
                    brewery={brewery}
                    brewery_id={brewery.id}
                    brewery_name={brewery.name}
                    fromBreweryPage={this.props.fromBreweryPage}
                    hideHeader={true}
                    adminOnly={this.props.adminOnly}
                />
            )
        }
    }

    getAddButtonText(){
        return this.props.fromBreweryPage ? 'Invite Users to Brewery' : 'Invite Admin Users'
    }

    render() {
        const className = this.state.expanded ? 'open' : '';
        return (
            <div className="row w100 invites">
                <div className="row w100 margin-bottom-sm margin-top-sm">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-6 text-right">
                        <div>
                            <div className={`invite blue expander ${className}`} ></div>
                            <a id="invite_users" onClick={this.onClick} className={'button-link'}>{this.getAddButtonText()}</a>
                        </div>
                    </div>

                    <div className="col-sm-3"></div>
                </div>
                {
                    this.inviteeForm()
                }
            </div>
        );
    }
}

export default InviteExpander